// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import LoginController from "./login_controller"
application.register("login", LoginController)

import RaviController from "./ravi_controller"
application.register("ravi", RaviController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)
